module.exports = __webpack_public_path__ + "static/img/springAndsummer_jianjiePic.48e231e5.png";